import React, { createContext, useContext } from 'react';
import { resolveStyles, resolveClassName } from 'treat';

const treatThemeContext = /*#__PURE__*/createContext(null);
const TreatProvider = ({
  theme,
  children
}) => /*#__PURE__*/React.createElement(treatThemeContext.Provider, {
  value: theme
}, children);
const useTheme = () => {
  const theme = useContext(treatThemeContext);

  if (!theme) {
    throw new Error('No treat theme provided');
  }

  return theme;
};
const useStyles = styles => resolveStyles(useTheme(), styles);
const useClassName = classRef => resolveClassName(useTheme(), classRef);

export { TreatProvider, useClassName, useStyles, useTheme };
